import styled from 'styled-components';

import { Stack } from '@mui/material';
import { BuildOutlined } from '@mui/icons-material';
import { AITool } from '@components/Workspace/routes/Assistants/Assistant/AssistantTools/tool.types';
import { AIAssistant } from '@requests/telnyx';
import { ListItemContainer, ListItemContent, ListItemIcon, ListItemProps } from './ListItem';

const ToolAssistantName = styled.pre`
  font-size: 12px;
  margin: 0;
`;

interface ToolItemProps extends ListItemProps<AITool> {
  assistants: AIAssistant[];
}

export const ToolListItem: React.FC<ToolItemProps> = (props) => {
  const { option, key, ...liProps } = props;

  const assistant = props.assistants.find((assistant) => assistant.id === option.assistant_id);
  if (!assistant) return null;

  return (
    <ListItemContainer key={key} {...liProps}>
      <ListItemIcon>
        <BuildOutlined sx={{ fontSize: '20px' }} />
      </ListItemIcon>
      <ListItemContent>
        <Stack>
          <Stack direction='row' alignItems='center' justifyContent='space-between'>
            <h1>{option.name}</h1>
            {assistant && <ToolAssistantName>{assistant.name}</ToolAssistantName>}
          </Stack>
          {option.description && <p>{option.description}</p>}
        </Stack>
      </ListItemContent>
    </ListItemContainer>
  );
};
